const date_time = {
	day: "Dag",
	month: "Maand",
	month_list: [
		"januari",
		"februari",
		"maart",
		"april",
		"mei",
		"juni",
		"juli",
		"augustus",
		"september",
		"oktober",
		"november",
		"december",
	],
	year: "Jaar",
};

export default date_time;
